import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { printBase64Pdf } from '../../utils/print';

export const PrintDocsModal = ({ show, handleClose, documents }) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Print documents</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul>
                    {
                        documents.map((d, index) => (
                            <li key={index}>
                                <Button onClick={() => printBase64Pdf(d.document)} className='link-btn'>{`Document ${index + 1} - ${d.type}`}</Button>
                            </li>
                        ))
                    }
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
